module.exports = __webpack_public_path__ + "img/3-2.ebff9973.png";